import List from "./components/List"
import Form from "./components/Form"

let module = "notificationtemplate"

export default [
  { path: "notificationtemplates", component: List, meta: { module: module, permissions: ["notificationtemplate-access"] } },
  {
    path: "notificationtemplates/create",
    component: Form,
    props: true,
    meta: { module: module, permissions: ["notificationtemplate-create"] }
  },
  {
    path: "notificationtemplates/edit/:id",
    component: Form,
    props: true,
    meta: { module: module, permissions: ["notificationtemplate-edit"] }
  }
]
